import {RequestHelper} from '@/helpers';

export default {
    NEW_SEGMENT_PLAN: RequestHelper.getQueryVariable('uat') === 'new_segment_plan' || false,
}